import { render, staticRenderFns } from "./NovaProgressTimeline.vue?vue&type=template&id=2dea54d4&scoped=true&lang=pug&"
import script from "./NovaProgressTimeline.vue?vue&type=script&lang=js&"
export * from "./NovaProgressTimeline.vue?vue&type=script&lang=js&"
import style0 from "./NovaProgressTimeline.vue?vue&type=style&index=0&id=2dea54d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dea54d4",
  null
  
)

export default component.exports